import { gql } from '@apollo/client';

import { dashboardFields } from './constants';

export const GET_MERGED_STATEMENT_VIEWS = gql`
    query getMergedStatementViews($ids: [ID!]) {
        getMergedStatementViews(ids: $ids) {
            id
            statement_id
            view {
                ${dashboardFields}
            }
        }
    }
`;
